/* eslint-disable */
export const nigerianCity = [
  {
    id: 123,
    name: 'Abuja',
    image: 'citiesImages/abuja.jpg',
  },
  {
    id: 124,
    name: 'Abia',
    image: 'citiesImages/abia.jpg',
  },
  {
    id: 125,
    name: 'Benin',
    image: 'citiesImages/Benin.jpg',
  },
  {
    id: 126,
    name: 'Enugu',
    image: 'citiesImages/enugu.jpg',
  },
  {
    id: 127,
    name: 'Ibadan',
    image: 'citiesImages/ibadan.jpg',
  },
  {
    id: 128,
    name: 'Ilorin',
    image: 'citiesImages/ilorin.jpg',
  },
  {
    id: 129,
    name: 'Jos',
    image: 'citiesImages/jos.jpg',
  },
  {
    id: 1231,
    name: 'Kaduna',
    image: 'citiesImages/kaduna.jpg',
  },
  {
    id: 1232,
    name: 'Kano',
    image: 'citiesImages/kano.jpg',
  },
  {
    id: 1234,
    name: 'Lagos',
    image: 'citiesImages/lagos.jpg',
  },
  {
    id: 1235,
    name: 'Maiduguri',
    image: 'citiesImages/maiduguri.jpg',
  },
  {
    id: 1236,
    name: 'Port',
    image: 'citiesImages/Ph.jpg',
  },
];
